import { render } from "./AppHomeDialog.vue?vue&type=template&id=6204bd78&scoped=true&ts=true"
import script from "./AppHomeDialog.vue?vue&type=script&lang=ts"
export * from "./AppHomeDialog.vue?vue&type=script&lang=ts"

import "./AppHomeDialog.vue?vue&type=style&index=0&id=6204bd78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6204bd78"]])

export default __exports__